exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".details-group.bookmarked-comments-of-company[data-v-7b3a8253]{background:rgba(255,0,0,.1411764705882353)}.bookmarked-comments-of-company p[data-v-7b3a8253]{margin-bottom:5px}", ""]);

// exports
